import { useMutation } from 'react-query';
import axios from 'axios';
import { TerminalAppearanceAPI } from '../../../constants/API';
import { queryClient } from '../../../queryClient';
import { multipartHeaders } from '../../../constants/HeadersAPI';
import { useContext } from 'react';
import { AlertContext } from '../../../context/AlertProvider';
import { AlertType } from '../../../types/enums';
import { defaultSuccessMessage } from '../../../constants/alertText';
import { TerminalScreensaverMedia } from '../../../types/Admin/TerminalAppearanceTypes';

export const usePostTerminalScreensaverMedia = (branchQueueId: number | null) => {
  const context = useContext(AlertContext);

  const {
    mutateAsync: uploadTerminalScreensaverMedia,
    isLoading: isUploadTerminalScreensaverMediaLoading,
  } = useMutation(
    ['TerminalAppearanceUploadScreensaver'],
    (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      return axios.post<TerminalScreensaverMedia>(
        TerminalAppearanceAPI.uploadScreensaverMedia(branchQueueId!),
        formData,
        multipartHeaders(),
      );
    },
    {
      onSuccess: () => {
        queryClient
          .invalidateQueries('TerminalAppearance')
          .then(() =>
            context?.setAlert({
              type: AlertType.Success,
              message: defaultSuccessMessage,
            }),
          );
      },
    },
  );

  return {
    uploadTerminalScreensaverMedia,
    isUploadTerminalScreensaverMediaLoading,
  };
};
